module.exports = __webpack_public_path__ + "img/winerackdog44.e4c02aca.jpg";